


























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class PopupBannerImageMap extends Vue {
  @Prop({ default: '' }) private readonly title: string;
  @Prop({ default: '' }) private readonly imageMapData: string;
  private temporaryImageMapData: string = this.imageMapData;

  get placeHolder(): string {
    return (
      `${this.$t('BANNER_LIST_PLACEHOLDER_IMAGE_MAP')}` +
      '\n<area shape="rect" coords="42,41,154,66" href="/page1.php" target="_blank">' +
      '\n<area shape="rect" coords="42,76,152,100" href="/page2.php" target="_blank">'
    );
  }

  private onClickSubmit(): void {
    const isValid = this.validation();

    if (isValid) this.onSaveData();
  }

  private onClickCancel(): void {
    this.$emit('onClose');
  }

  private onSaveData() {
    this.$emit('onSubmit', {
      imageMap: this.temporaryImageMapData,
    });

    this.$emit('onClose');
  }

  private validation(): boolean {
    const isNotEmpty = !!this.temporaryImageMapData.trim();

    if (!isNotEmpty) {
      alert(this.$t('ALERT_EMPTY_CONTENT').toString());
      (this.$refs.imageMapInput as HTMLTextAreaElement).focus();
    }

    return isNotEmpty;
  }
}
